/* Blessed Choice — Calculadora de frete no PDP (v1.3) — paridade Yampi
 * Cota CARRINHO ATUAL + este produto (o mesmo conjunto que a Yampi cotará no checkout).
 * Sem dependências. Lê a variante atual do formulário do tema Evolution
 * ([name="id"] — select ou input hidden — ou ?variant= na URL) e a quantidade
 * ([name="quantity"]), e envia peso/preço da variante ao Worker.
 */
(function () {
  'use strict';
  if (customElements.get('bc-frete')) return;

  var STORAGE_KEY = 'bc_frete_cep';
  var BRL = function (v) { return 'R$ ' + Number(v).toFixed(2).replace('.', ','); };
  var maskCep = function (v) { v = String(v || '').replace(/\D/g, '').slice(0, 8); return v.length > 5 ? v.slice(0, 5) + '-' + v.slice(5) : v; };
  var read = function (k) { try { return localStorage.getItem(k); } catch (e) { return null; } };
  var save = function (k, v) { try { localStorage.setItem(k, v); } catch (e) {} };

  class BcFrete extends HTMLElement {
    connectedCallback() {
      this.endpoint = this.dataset.endpoint;
      this.showAll = this.dataset.showAll !== 'false';
      this.qtySelector = this.dataset.qtySelector || '[name="quantity"]';
      this.productId = this.dataset.productId || '';
      this.variants = [];
      try { this.variants = JSON.parse(this.querySelector('[data-bc-variants]').textContent); } catch (e) {}

      this.form = this.closest('form[action*="/cart/add"]') || document.querySelector('form[action*="/cart/add"]');
      this.input = this.querySelector('[data-bc-cep]');
      this.btn = this.querySelector('[data-bc-calc]');
      this.out = this.querySelector('[data-bc-result]');
      this.lastKey = null;

      var self = this;
      this.input.addEventListener('input', function (e) { e.target.value = maskCep(e.target.value); });
      this.input.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); self.quote(); } });
      this.btn.addEventListener('click', function (e) { e.preventDefault(); self.quote(); });

      // Variante (swatch/select) ou quantidade (+/-) mudou → recalcula se já houver CEP
      var timer;
      var recheck = function () {
        clearTimeout(timer);
        timer = setTimeout(function () { if (self.input.value.length === 9 && self.lastKey) self.quote(true); }, 300);
      };
      document.addEventListener('change', recheck);
      document.addEventListener('click', function (e) { if (self.form && self.form.contains(e.target) && !self.contains(e.target)) recheck(); });
      window.addEventListener('popstate', recheck);
      // Depois de "Adicionar ao carrinho", o carrinho mudou → recota com o novo conteúdo
      document.addEventListener('click', function (e) {
        if (e.target.closest('[data-action="add-to-cart"], .product-form__add-button')) {
          setTimeout(function () { self.lastKey = null; if (self.input.value.length === 9) self.quote(true); }, 2500);
        }
      });

      var stored = read(STORAGE_KEY);
      if (stored && stored.length === 9) { this.input.value = stored; this.quote(true); }
    }

    currentVariant() {
      var id = null;
      if (this.form) {
        var el = this.form.querySelector('[name="id"]:checked') || this.form.querySelector('[name="id"]');
        if (el && el.value) id = el.value;
      }
      var urlId = new URL(location.href).searchParams.get('variant');
      if (urlId) id = urlId; // a URL é atualizada pelo tema a cada troca de variante
      var v = null;
      for (var i = 0; i < this.variants.length; i++) if (String(this.variants[i].id) === String(id)) v = this.variants[i];
      return v || this.variants[0] || null;
    }

    currentQty() {
      var el = (this.form && this.form.querySelector(this.qtySelector)) || document.querySelector(this.qtySelector);
      var n = el ? parseInt(el.value, 10) : 1;
      return n > 0 ? n : 1;
    }

    setState(html, cls) {
      this.out.className = 'bc-frete__result' + (cls ? ' bc-frete__result--' + cls : '');
      this.out.innerHTML = html;
      this.out.dataset.ok = cls === 'ok' ? '1' : '';
    }

    quote(silent) {
      var cep = this.input.value;
      if (cep.length !== 9) { if (!silent) { this.setState(this.msg('invalid'), 'error'); this.input.focus(); } return; }
      var v = this.currentVariant();
      if (!v) { this.setState(this.msg('nosku'), 'error'); return; }
      var qty = this.currentQty();
      var self = this;
      save(STORAGE_KEY, cep);
      this.btn.disabled = true;
      this.setState('<span class="bc-frete__spinner" aria-hidden="true"></span> ' + this.msg('loading'), 'loading');

      this.getCart().then(function (cart) {
        // carrinho atual + este produto (se já estiver no carrinho, soma a quantidade)
        var items = cart.slice(), found = false;
        for (var i = 0; i < items.length; i++) if (String(items[i].variant_id) === String(v.id)) { items[i].quantity += qty; found = true; }
        if (!found) items.push({ variant_id: v.id, product_id: self.productId, sku: v.sku || '', price: v.price, weight: v.weight, quantity: qty });
        var cartQty = cart.reduce(function (n, it) { return n + it.quantity; }, 0);
        var key = cep + '|' + items.map(function (it) { return it.variant_id + 'x' + it.quantity; }).join(',');
        self.lastKey = key;

        var ctrl = typeof AbortController !== 'undefined' ? new AbortController() : null;
        var t = setTimeout(function () { if (ctrl) ctrl.abort(); }, 12000);
        return fetch(self.endpoint, {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ zipcode: cep, items: items }),
          signal: ctrl ? ctrl.signal : undefined
        }).then(function (r) { return r.json(); }).then(function (j) {
          if (self.lastKey !== key) return; // resposta antiga
          if (!j.ok) { self.setState(self.msg('error'), 'error'); return; }
          if (j.blocked) { self.setState(self.msg('blocked'), 'blocked'); return; }
          if (!j.quotes || !j.quotes.length) { self.setState(self.msg('error'), 'error'); return; }
          self.render(j.quotes, qty, cartQty);
          if (window.dataLayer) window.dataLayer.push({ event: 'bc_frete_calculado', cep: cep, uf: j.uf, variant_id: v.id, quantity: qty, cart_quantity: cartQty, cheapest: j.quotes[0].price });
        }).finally(function () { clearTimeout(t); });
      }).catch(function () { self.setState(self.msg('error'), 'error'); })
        .finally(function () { self.btn.disabled = false; });
    }

    /** Itens do carrinho Shopify (/cart.js) no formato do Worker. Falha → carrinho vazio. */
    getCart() {
      return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.ok ? r.json() : { items: [] }; })
        .then(function (c) {
          return (c.items || []).map(function (it) {
            return { variant_id: it.variant_id, product_id: it.product_id, sku: it.sku || '', price: (it.final_price || it.price) / 100, weight: (it.grams || 0) / 1000, quantity: it.quantity };
          });
        }).catch(function () { return []; });
    }

    render(quotes, qty, cartQty) {
      var self = this;
      var cheapest = quotes[0];
      var fastest = quotes.slice().sort(function (a, b) { return a.days - b.days || a.price - b.price; })[0];
      var list = this.showAll ? quotes : quotes.filter(function (q) { return q === cheapest || q === fastest; });
      var rows = list.map(function (q) {
        var tag = q === cheapest ? '<em class="bc-frete__tag">' + self.msg('cheapest') + '</em>'
          : (q === fastest ? '<em class="bc-frete__tag bc-frete__tag--fast">' + self.msg('fastest') + '</em>' : '');
        var price = q.price === 0 ? '<strong class="bc-frete__price bc-frete__price--free">' + self.msg('free') + '</strong>'
          : '<strong class="bc-frete__price">' + BRL(q.price) + '</strong>';
        return '<li class="bc-frete__row' + (q === cheapest ? ' bc-frete__row--best' : '') + '">' +
          '<span class="bc-frete__name"><span>' + self.esc(q.name) + tag + '</span>' +
          '<small>' + self.msg('days').replace('{days}', q.days) + '</small></span>' + price + '</li>';
      }).join('');
      var note = cartQty > 0
        ? this.msg('noteCart').replace('{total}', qty + cartQty).replace('{cart}', cartQty).replace('{qty}', qty)
        : this.msg('note').replace('{qty}', qty);
      this.setState('<ul class="bc-frete__list">' + rows + '</ul>' + (note ? '<p class="bc-frete__note">' + note + '</p>' : ''), 'ok');
    }

    msg(k) { return this.dataset['msg' + k.charAt(0).toUpperCase() + k.slice(1)] || ''; }
    esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  }
  customElements.define('bc-frete', BcFrete);
})();
